import {
    AppstoreAddOutlined,
    AntDesignOutlined,
    BarcodeOutlined,
    BgColorsOutlined,
    FontSizeOutlined,
    DatabaseOutlined,
    FileTextOutlined,
    LoadingOutlined,
    UserOutlined,
    DollarOutlined,
    FormOutlined,
    SendOutlined,
    FileDoneOutlined,
  } from "@ant-design/icons";
import { Typography } from "@mui/material";
  
  const icons = {
    FontSizeOutlined,
    BgColorsOutlined,
    BarcodeOutlined,
    AntDesignOutlined,
    LoadingOutlined,
    DatabaseOutlined,
    FileTextOutlined,
    AppstoreAddOutlined,
    UserOutlined,
    DollarOutlined,
    FormOutlined,
    SendOutlined,
    FileDoneOutlined,
  };
  
  const production = {
    id: "production",
    title: (
      <Typography variant="h5" component="div">
        Production
      </Typography>
    ),
    type: "accordion",
    children: [
      {
        id: "blends",
        title: "Blends",
        type: "item",
        url: "/blend-view",
        icon: icons.FileTextOutlined,
      },
      {
        id: "batches",
        title: "Batches",
        type: "item",
        url: "/batch-view",
        icon: icons.DatabaseOutlined,
      },
      {
        id: "batch-cost-overview",
        title: "Batch Cost Overview",
        type: "item",
        url: "/batch-cost-overview",
        icon: icons.DollarOutlined,
      },
      {
        id: "admin-cost-rate-view",
        title: "Admin Cost Rates",
        type: "item",
        url: "/admin-cost-rate-view",
        icon: icons.FormOutlined,
      },
    ],
  };
  
  export default production;
  